import React, { useEffect, useState } from 'react';
import { HomePage } from './pages/HomePage';
import { DaedoPSSSystemPage } from './pages/DaedoPSSSystemPage';
import { DaedoProductsPage } from './pages/DaedoProductsPage';
import { WacokuProductsPage } from './pages/WacokuProductsPage';
import { Gen3Page } from './pages/Gen3Page';
import { ShopAllPage } from './pages/ShopAllPage';
import { ComingSoonPage } from './pages/ComingSoonPage';
import { ThresholdsPage } from './pages/ThresholdsPage';
import { EFootPage } from './pages/EFootPage';
import { FinancingPage } from './pages/FinancingPage';
import { ReturnsPage } from './pages/ReturnsPage';
export function App() {
  const [currentPage, setCurrentPage] = useState<'home' | 'daedo-pss' | 'daedo-products' | 'wacoku-products' | 'gen3' | 'shop-all' | 'support-thresholds' | 'support-software' | 'support-troubleshooting' | 'support-efoot' | 'financing' | 'returns'>('home');
  // Simple routing based on hash
  useEffect(() => {
    const handleHashChange = () => {
      const hash = window.location.hash.slice(1);
      if (hash === 'daedo-pss-systems') {
        setCurrentPage('daedo-pss');
      } else if (hash === 'daedo-products') {
        setCurrentPage('daedo-products');
      } else if (hash === 'wacoku-products') {
        setCurrentPage('wacoku-products');
      } else if (hash === 'gen3') {
        setCurrentPage('gen3');
      } else if (hash === 'shop-all') {
        setCurrentPage('shop-all');
      } else if (hash === 'support-thresholds') {
        setCurrentPage('support-thresholds');
      } else if (hash === 'support-software') {
        setCurrentPage('support-software');
      } else if (hash === 'support-troubleshooting') {
        setCurrentPage('support-troubleshooting');
      } else if (hash === 'support-efoot') {
        setCurrentPage('support-efoot');
      } else if (hash === 'financing') {
        setCurrentPage('financing');
      } else if (hash === 'returns') {
        setCurrentPage('returns');
      } else {
        setCurrentPage('home');
      }
    };
    handleHashChange();
    window.addEventListener('hashchange', handleHashChange);
    return () => window.removeEventListener('hashchange', handleHashChange);
  }, []);
  if (currentPage === 'daedo-pss') {
    return <DaedoPSSSystemPage data-id="element-0" />;
  }
  if (currentPage === 'daedo-products') {
    return <DaedoProductsPage data-id="element-1" />;
  }
  if (currentPage === 'wacoku-products') {
    return <WacokuProductsPage data-id="element-2" />;
  }
  if (currentPage === 'gen3') {
    return <Gen3Page data-id="element-3" />;
  }
  if (currentPage === 'shop-all') {
    return <ShopAllPage data-id="element-4" />;
  }
  if (currentPage === 'support-thresholds') {
    return <ThresholdsPage data-id="element-5" />;
  }
  if (currentPage === 'support-software') {
    return <ComingSoonPage title="Download Scoring Software" description="Downloads for Gen2 and Gen3 scoring software will be available here soon." data-id="element-6" />;
  }
  if (currentPage === 'support-troubleshooting') {
    return <ComingSoonPage title="Troubleshooting Video" description="Video guides for troubleshooting your Daedo PSS equipment are coming soon." data-id="element-7" />;
  }
  if (currentPage === 'support-efoot') {
    return <EFootPage data-id="element-8" />;
  }
  if (currentPage === 'financing') {
    return <FinancingPage data-id="element-9" />;
  }
  if (currentPage === 'returns') {
    return <ReturnsPage data-id="element-10" />;
  }
  return <HomePage data-id="element-11" />;
}